module.exports = __webpack_public_path__ + "static/media/cctv.4866f3a9.svg";